

















import { Component, Vue, Prop } from 'vue-property-decorator';
import ItemQuestion from '@/components/collection-items/collection-item-component/ItemQuestion.vue';
import ItemTitle from '@/components/collection-items/collection-item-component/ItemTitle.vue';
import ItemInfo from '@/components/collection-items/collection-item-component/ItemInfo.vue';
import {
  CollectionItem,
  CollectionItemType,
} from '@/resource/collection-item/collection-item.model';

@Component({
  components: {
    ItemQuestion,
    ItemTitle,
    ItemInfo,
  },
})
export default class ComponentCollectionItem extends Vue {
  @Prop({ required: true })
  collectionItem!: CollectionItem;

  @Prop({ required: true })
  showRearrangePositions!: boolean;

  @Prop({ required: true })
  deleteItemClicked!: () => void;

  showInfo = false;

  get getComponent(): string {
    let compName = '';

    const collectionItemType = this.collectionItem.collectionItemType;

    switch (collectionItemType) {
      case CollectionItemType.Objective:
        compName = 'ItemQuestion';
        break;
      case CollectionItemType.Subjective:
        compName = 'ItemQuestion';
        break;
      case CollectionItemType.Title:
        compName = 'ItemTitle';
        break;
    }

    return compName;
  }

  closeInfo() {
    this.showInfo = false;
  }

  oepnInfo() {
    if (
      this.collectionItem.collectionItemType === CollectionItemType.Title ||
      this.showRearrangePositions
    )
      return;
    this.showInfo = true;
  }
}
